import {EntityLinkedToAccountWithAuditMetadata} from '../../../../../common/entity/entityLinkedToAccountWithAuditMetadata';
import {Moment} from 'moment-timezone';
import {AgendaCategory} from '../../../category/api/entity/agendaCategory.model';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {AgendaCalendarModel} from '../../../calendar/api/entity/agendaCalendar.model';
import {PersonSummaryModel} from '../../../../../person/api/entity/personSummary.model';
import {PhoneModel} from '../../../../../common/phone/entity/phone.model';
import {AgendaEventRecurrenceSummaryModel} from './agendaEventRecurrenceSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {OnlineFormSummaryModel} from '../../../../../online-form/form/api/entity/onlineFormSummary.model';
import {AgendaEventAutoGeneratedLabelModel} from './agendaEventAutoGeneratedLabel.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {UserSummary} from '../../../../../account/modules/user/api/entity/userSummary.model';
import {AgendaCalendarSummaryModel} from "../../../calendar/api/entity/agendaCalendarSummary.model";
import {AgendaCategorySummaryModel} from "../../../category/api/entity/agendaCategorySummary.model";

export class AgendaEventSummaryModel extends EntityLinkedToAccountWithAuditMetadata implements SummaryModel {
    id: number;
    start: Moment;
    end: Moment;
    category: AgendaCategorySummaryModel;
    calendars: AgendaCalendarSummaryModel[] = [];
    allDay = false;
    partner: PartnerSummaryModel;
    onlineBooking = false;
    label: string;
    email: string;
    phone: PhoneModel;
    comment: string;
    recurrence: AgendaEventRecurrenceSummaryModel;
    synchronizedWithPartner: boolean;
    autoGeneratedLabel: AgendaEventAutoGeneratedLabelModel;
    reminderBySms = false;
    reminderByEmail = false;
    cancellationType: LovValueSummary;
    cancelledUser: UserSummary;
    cancellationReason: string;
    responsible: UserSummary;
    firstPartnerEvent: boolean;
    hasNotes: boolean;
    onWaitingList: boolean;
    partnerCanCancel: boolean;
    get longLabel(): string {
        let longLabel = '';

        const startFormatted = this.start.format('DD/MM/YYYY');
        const endFormatted = this.end.format('DD/MM/YYYY');

        longLabel += 'De ' + startFormatted + ' ' + this.start.format('HH:mm') + ' à ';
        if (startFormatted !== endFormatted) {
            longLabel += endFormatted + ' ';
        }
        longLabel += this.end.format('HH:mm');

        if (this.partner) {
            longLabel += ' - ' + this.partner.name;
        }
        return longLabel;
    }
}

export enum AgendaEventCancellationType {
    AGENDA_EVENT_CANCELLATION_TYPE_BY_USER = 'AGENDA_EVENT_CANCELLATION_TYPE_BY_USER',
    AGENDA_EVENT_CANCELLATION_TYPE_BY_PARTNER = 'AGENDA_EVENT_CANCELLATION_TYPE_BY_PARTNER',
}
